import { REUSE_NETWORK, spokenLabel } from '../../constants/mapConfig'
import reuseSitesData from '../../data/reuseSites.json'
import type { ReuseSite } from '../../types'
import SpokenAT from '../SpokenAT'

const reuseSites = reuseSitesData as ReuseSite[]

interface ReuseNetworkRowProps {
  isSelected: boolean
  onClick: () => void
}

export default function ReuseNetworkRow({ isSelected, onClick }: ReuseNetworkRowProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      // See SiteListCard's equivalent comment — aria-current models "the currently-shown item"
      // more accurately than aria-pressed, which implies clicking again toggles it back off.
      aria-current={isSelected ? 'true' : undefined}
      aria-label={`${spokenLabel(REUSE_NETWORK.name)} — ${reuseSites.length} independently-run equipment-reuse sites across Pennsylvania`}
      style={{
        all: 'unset',
        display: 'flex',
        width: '100%',
        boxSizing: 'border-box',
        padding: '10px 14px',
        gap: 10,
        background: isSelected ? '#f0f5ff' : '#f8f9fb',
        cursor: 'pointer',
        borderBottom: '1px solid #f1f5f9',
        borderLeft: isSelected ? '3px solid #004090' : '3px solid transparent',
        alignItems: 'center',
      }}
    >
      <div
        aria-hidden="true"
        style={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          flexShrink: 0,
          border: '1.5px dashed #8890a0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(91,98,112,0.08)',
        }}
      >
        <span style={{ fontSize: '0.75rem', fontWeight: 800, color: '#4b5563' }}>{reuseSites.length}</span>
      </div>
      <div style={{ flex: 1, minWidth: 0, textAlign: 'left' }}>
        <div style={{ fontWeight: 700, fontSize: '0.85rem', color: 'var(--text-strong)' }}>
          <SpokenAT text={REUSE_NETWORK.name} />
        </div>
        <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)', marginTop: 2 }}>
          {reuseSites.length} independently-run equipment-reuse programs across Pennsylvania
        </div>
      </div>
    </button>
  )
}
